export enum VerticalSkin {
	Default = '',
}

let verticalSkin: VerticalSkin | undefined = undefined;

export function getVerticalSkin() {
	return verticalSkin;
}

export function setVerticalSkinIfNotSet(force = false) {
	if (force || !verticalSkin) {
		verticalSkin = VerticalSkin.Default;
	}
}
